'use client'

import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import EnquiryPopup from './EnquiryPopup'

const Navbar = () => {
  const [isScroll, setIsScroll] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false)

  const openMenu = () => setIsMenuOpen(true)
  const closeMenu = () => setIsMenuOpen(false)

  useEffect(() => {
    const handleScroll = () => setIsScroll(window.scrollY > 50)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // 点击 mobile Enquire now
  const handleEnquireClick = () => {
    if (isMenuOpen) {
      closeMenu() // 先关闭菜单
      setTimeout(() => setIsEnquiryOpen(true), 200) // 延时弹窗
    } else {
      setIsEnquiryOpen(true)
    }
  }

  return (
    <nav
      className={`fixed top-0 w-full lg:px-30 px-[5%] py-4 flex items-center justify-between z-50 transition duration-300  bg-white ${
        isScroll ? 'shadow-sm' : ''
      }`}
    >
      {/* Logo */}
      <Link href="#top" className="flex items-center space-x-2">
        <Image
          src="/simoomco.webp"
          alt="company logo"
          width={200}
          height={200}
          className="w-32  md:w-40 lg:w-48 xl:w-52 h-auto"
        />
      </Link>

      {/* Desktop Menu */}
      <ul className="hidden md:flex items-center justify-end ml-auto 2xl:text-xl gap-8 lg:gap-12">
        <li>
  <Link className="font-Ovo border border-transparent text-lg hover:border-black px-2 py-1" href="#top">
    Home
  </Link>
</li>
<li>
  <Link className="font-Ovo border border-transparent text-lg hover:border-black px-2 py-1" href="/#services">
    Services
  </Link>
</li>
<li>
  <Link className="font-Ovo border border-transparent text-lg hover:border-black px-2 py-1" href="#contact">
    Contact
  </Link>
</li>

        <li>
          <Link className="font-Ovo border border-transparent text-lg hover:border-black px-2 py-1" href="/about">
            About
          </Link>
        </li>
        <li>
          <button
            className="cursor-pointer px-6 py-3 text-white bg-gradient-to-r from-indigo-600 to-purple-600   hover:from-indigo-300 hover:to-purple-400 rounded-full font-semibold hover:bg-indigo-500 transition"
            onClick={() => setIsEnquiryOpen(true)}
          >
            Enquire now
          </button>
        </li>
      </ul>

      {/* Mobile menu button */}
      <button onClick={openMenu} aria-label="open menu" className="block md:hidden ml-auto cursor-pointer">
        <Image src="/menu-black.png" alt="open menu" width={20} height={20} />
      </button>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && <div className="fixed inset-0 bg-black/30 z-40" onClick={closeMenu} />}

      {/* Mobile Menu */}
<ul
  className={`flex md:hidden flex-col gap-6 py-20 px-10 fixed right-0 top-0 w-64 h-screen
  bg-black transition-transform duration-500 z-50 ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}
>
  <li>
  <Link className="font-Ovo text-amber-100" href="#top" onClick={closeMenu}>
    Home
  </Link>
</li>
<li>
  <Link className="font-Ovo text-amber-100" href="#contact" onClick={closeMenu}>
    Contact
  </Link>
</li>

  <li>
    <Link className="font-Ovo text-amber-100" href="/about" onClick={closeMenu}>
      About
    </Link>
  </li>

  {/* 移动端 Enquire now 按钮 */}
  <li className="mt-auto"> 
    <button
      className="w-full bg-gradient-to-r from-indigo-300 to-purple-400 text-amber-100 border-white font-bold py-4 rounded-2xl shadow-lg hover:from-indigo-600 hover:to-purple-600 transition-all duration-300"
      onClick={handleEnquireClick}
    >
      Enquire now
    </button>
  </li>
</ul>


      {/* 弹窗 */}
      <EnquiryPopup isOpen={isEnquiryOpen} setIsOpen={setIsEnquiryOpen} />
    </nav>
  )
}

export default Navbar


